import pub from './../public';
const type = pub.getLang();

const language = {
  'zh-hk': {
    salePrice: '(迎新優惠)',
    title: '購買House730金幣',
    type: '放盤方式',
    money: '所需金幣',
    date: '放盤有效期',
    standard: '標準盤',
    sell_dish: '售盤',
    rent_out: '租盤',
    day: '日',
    // gold_top: '超級置頂盤',
    gold_top: '精選盤',
    rent_sale_day: '售盤/租盤',
    select_number: '選擇購買數量',
    stored_value: '購買House730金幣',
    // house_money: '金幣',
    select_payment_way: '選擇付款方式',
    payment_way: '付款方式',
    confirm: '確定',
    select_money: '你选择储值',
    wu_money: '金幣',
    select_sost: '費用HK$',
    payment: '並使用信用卡進行付款',
    cancel: '取消',
    payment_success: '您已成功完成儲值金幣',
    unit: '金幣',
    hk: 'HK$',
    list: [],
    pdCre:'信用卡',
    columns: ['paydollar','PayPal','AlipayHK','WeChat Pay HK', '銀行轉賬'],
    pay_success: '金幣已存入你的帳戶',
    rental: '付款總額',
    hint: '確定購買金幣？',
    next: '請按確定前往付款',
    succeed: '付款成功',
    Star: '星級盤',
    alipayText: '只適用於已註冊的Alipay HK用戶',
    wePayText: '只適用於已註冊的WeChat Pay HK用戶',
    transferFake: '(會在下一個工作天內處理完成)',
  },
  'zh-cn': {
    salePrice: '(迎新优惠)',
    title: '购买House730金币',
    type: '放盘方式',
    money: '所需金币',
    date: '放盘有效期',
    standard: '标准盘',
    sell_dish: '售盤',
    rent_out: '租盤',
    day: '日',
    gold_top: '精选盘',
    rent_sale_day: '售盘/租盘',
    stored_value: '购买House730金币',
    select_number: '选择购买数量',
    // house_money: '金币',
    select_payment_way: '选择付款方式',
    payment_way: '付款方式',
    confirm: '确定',
    select_money: '你选择储值',
    wu_money: '金币',
    select_sost: '費用HK$',
    payment: '并使用信用卡进行付款',
    cancel: '取消',
    payment_success: '您已成功完成储值金币',
    unit: '金币',
    hk: 'HK$',
    list: [],
    pdCre:'信用卡',
    columns: ['paydollar','PayPal','AlipayHK','WeChat Pay HK', '银行转账',],
    pay_success: '金币已存入你的账户',
    rental: '付款总额',
    hint: '确定购买金币？',
    next: '请按确定前往付款',
    succeed: '付款成功',
    Star: '星级盘',
    alipayText: '只适用于已注册的Alipay HK用戶',
    wePayText: '只适用于已注册的WeChat Pay HK用戶',
    transferFake: '(会在下一个工作天内处理完成)',
  },
  'en-us': {
    // salePrice: 'Opening Promotion',
    salePrice: '',
    title: 'Buy House730 Gold Coin',
    type: 'Listing Method',
    money: 'Gold Coin',
    date: 'Validity',
    standard: 'Standard',
    sell_dish: 'Sale:',
    rent_out: 'Rent:',
    day: 'days',
    gold_top: 'Featured',
    rent_sale_day: 'Sales/Rent',
    stored_value: 'Buy House730 Gold Coin',
    select_number: 'Choose your package',
    // house_money: 'house money', //待定
    select_payment_way: 'Choose payment method',
    payment_way: 'Payment Method',
    confirm: 'OK',
    select_money: 'You choose stored values',
    wu_money: 'golds',
    select_sost: 'expense HK$',
    payment: 'And pay by credit card',
    cancel: 'Cancel',
    payment_success: 'You have successfully completed the deposit currency',
    unit: 'Gold Coin',
    hk: 'HK$',
    list: [],
    pdCre:'Credit Card',
    columns: ['paydollar','PayPal','AlipayHK','WeChat Pay HK', 'Bank Transfer '],
    pay_success: 'Gold Coin has been credited to your account',
    rental: 'Amount',
    hint: 'Buy Gold Coin now?',
    next: 'Click OK to proceed payment',
    succeed: '	Payment Successful',
    Star: 'Premium',
    alipayText: 'only applicable to AlipayHK registered users',
    wePayText: 'only applicable to WeChat Pay HK registered users',
    transferFake: '(will be handled on/before next working day)',
  }
};
export default language[type];
